._customTemplateTextAndLinkDropPanel_6vfsb_1 {
  flex-direction: column;
  width: 204px; }
  ._customTemplateTextAndLinkDropPanel_6vfsb_1 ._dropPanelBody_6vfsb_4 {
    margin-top: 6px; }
  ._customTemplateTextAndLinkDropPanel_6vfsb_1 ._secondParagraph_6vfsb_6 {
    margin-top: 6px; }
  ._customTemplateTextAndLinkDropPanel_6vfsb_1 ._linksWrapper_6vfsb_8 {
    margin-top: 6px; }
